import { Routes } from '@angular/router';
import { MainLayoutComponent } from './app/layout/main-layout/main-layout.component';
import { NotFoundPage } from './app/features/notfound/notfound';
import { authGuard } from './app/core/guards/auth.guard';
import { mfaGuard } from './app/core/guards/mfa.guard';
import { AuthLayoutComponent } from './app/layout/auth-layout/auth-layout.component';
import { AuthCheckComponent } from './app/layout/auth-check/auth-check.component';



export const appRoutes: Routes = [
    // Root route with authentication check
    {
        path: '',
        component: AuthCheckComponent,
        pathMatch: 'full'
    },

    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard, mfaGuard],
        children: [
            { path: 'home',
                loadComponent: () => import('./app/features/home/home.component').then((m) => m.HomeComponent),
                data: { title: 'Home', icon: 'home' }
             },
            {
                path: 'doc-viewer',
                loadComponent: () => import('./app/features/doc-viewer/doc-viewer.component').then((m) => m.DocViewerComponent),
                data: { title: 'Doc-Viewer', icon: '' }
            },
        ]
    },
    { path: 'notfound', component: NotFoundPage },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'login',
                loadComponent: () => import('./app/features/login/login.component').then((m) => m.LoginComponent),
                data: { title: 'Login', icon: 'login' }
            },
            {
                path: 'register',
                loadComponent: () => import('./app/features/register/register.component').then((m) => m.RegisterComponent),
                data: { title: 'Register', icon: 'person_add' }
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('./app/features/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
                data: { title: 'Forgot Password', icon: 'lock_reset' }
            },
            {
                path: 'setup-mfa',
                canActivate: [authGuard],
                loadComponent: () => import('./app/features/setup-mfa/setup-mfa.component').then((m) => m.SetupMfaComponent),
                data: { title: 'Setup MFA', icon: 'verified_user' }
            },
            {
                path: 'unauthorized',
                loadComponent: () => import('./app/features/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
                data: { title: 'Unauthorized', icon: 'lock' }
            },
            // Redirect to login
            { path: '', redirectTo: 'login', pathMatch: 'full' }
        ]
    },
    { path: '**', redirectTo: '/notfound' }
];
